export const testimonials = [
    {
      name: "James Harnandez",
      role: "CEO, New York Properties Ltd",
      content: "DevsKe built our real estate platform that increased our leads by 300%. Their team is professional and delivers on time."
    },
    {
      name: "Sarah Woodley",
      role: "Marketing Director, BTS Sports",
      content: "Our sports betting platform developed by DevsKe handles thousands of transactions daily without issues. Highly recommended!"
    },
    {
      name: "David Smith",
      role: "CTO, TechSavvy Ltd",
      content: "We've worked with DevsKe on multiple cloud migration projects. Their expertise in AWS and Azure is impressive."
    }
  ];